import React, { Suspense } from "react";
import { Canvas } from "@react-three/fiber";
import { OrbitControls, Preload, useGLTF } from "@react-three/drei";

import CanvasLoader from "./CanvasLoader";

const MailBox = () => {
  const mailBox = useGLTF("./mailBox/scene.gltf");

  return <primitive object={mailBox.scene} scale={2} position-y={-20} />;
};

const MailBoxCanvas = () => {
  return (
    <Canvas
      shadows
      frameloop="demand"
      camera={{
        position: [-10, 0, 10],
      }}
    >
      <OrbitControls
        enablePan={false}
        enableZoom={false}
        autoRotate
        maxPolarAngle={Math.PI / 2}
        minPolarAngle={Math.PI / 2}
      />
      <Suspense fallback={<CanvasLoader />}>
        <ambientLight intensity={1} />
        <spotLight position={[0, 0, 0]} angle={2} penumbra={1} />
        <pointLight position={[-10, -10, -10]} />
        <MailBox />

        <Preload all />
      </Suspense>
    </Canvas>
  );
};

export default MailBoxCanvas;
